module.exports = __webpack_public_path__ + "img/balkonglasdach_2.c61a159e.webp";